function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { Box, sx, Text, themeGet } from '../..';
function getSafeValue(value = 0) {
  if (value < 0) {
    return 0;
  }
  return value;
}
export function formatValue(value, max) {
  const safeValue = getSafeValue(value);
  const safeMax = getSafeValue(max);
  if (safeMax && safeMax < safeValue) {
    return `${safeMax}+`;
  }
  if (safeValue === Infinity) {
    return '∞';
  }
  return safeValue.toString();
}
/**
 * Provides a drop-in replacement for badges that format numbers in Atlassian products.
 *
 * @TODO: adds an additional `disabled` prop; update component in Figma
 */
const AtlasBadge = ({
  appearance = 'default',
  children = 0,
  max = 99,
  style,
  testId,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    appearance: appearance
  }, props), /*#__PURE__*/React.createElement(Text, {
    sx: {
      fontSize: 1,
      lineHeight: '16px',
      textAlign: 'center',
      color: textColors[appearance]
    }
  }, typeof children === 'number' && max ? formatValue(children, max) : children));
};
AtlasBadge.displayName = "AtlasBadge";
const Wrapper = styled(Box).withConfig({
  displayName: "AtlasBadge__Wrapper",
  componentId: "sc-1vvppth-0"
})(["display:inline-flex;line-height:20px;padding-inline:0.375rem;border-radius:8px;background-color:", ";", ";"], p => p.appearance === 'added' ? themeGet('colors.background.success.default') : p.appearance === 'default' ? themeGet('colors.background.neutral.default') : p.appearance === 'important' ? themeGet('colors.background.danger.default') : p.appearance === 'primary' ? themeGet('colors.background.brand.bold.default') : p.appearance === 'primaryInverted' ? themeGet('colors.surface.default') : p.appearance === 'removed' ? themeGet('colors.background.danger.default') : p.appearance === 'disabled' ? themeGet('colors.background.neutral.default') : 'revert', sx);
AtlasBadge.displayName = 'AtlasBadge';
export default AtlasBadge;
const backgroundColors = {
  added: 'colors.background.success.default',
  default: 'colors.background.neutral.default',
  important: 'colors.background.danger.bold',
  primary: 'colors.background.brand.bold',
  primaryInverted: 'colors.elevation.surface.default',
  removed: 'background.danger.default',
  disabled: 'background.neutral.default'
};
const textColors = {
  added: 'text.success',
  default: 'text.default',
  important: 'text.inverse',
  primary: 'text.inverse',
  primaryInverted: 'text.brand',
  removed: 'text.danger',
  disabled: 'text.disabled'
};